<template>
  <el-form-item
    class="warm"
    :rules="rules"
    :prop="type"
  >
    <el-card shadow="never" class="warm-container">
      <div class="warm-title">
        {{ title }}
      </div>
      <el-radio-group
        v-model="standardType"
        @change="change"
      >
        <div class="radio-item">
          <el-radio :disabled="disabled" :label="'DEFAULT'">
            国标（{{ standard }}）
          </el-radio>
        </div>
        <div class="radio-item">
          <el-radio :label="'CUSTOM'" :disabled="disabled">
            客户自定义
            <el-tooltip
              class="item"
              effect="dark"
              placement="top-start"
            >
              <i class="el-icon-question" />
              <div slot="content">
                可设置里程范围内，对于温区的个性化温度要求；<br>不填写，即其他全部里程都默认使用右侧的温度作为指标
              </div>
            </el-tooltip>
          </el-radio>
          <div v-if="localValue[0] && localValue[0].type === 'CUSTOM'" class="radio-input">
            <template v-if="localValue">
              <div
                v-for="(item,index) in localValue"
                :key="index"
                class="customize-item"
              >
                <div class="distance">
                  <el-input
                    v-model="item.minMileage"
                    :style="{width:'60px'}"
                    size="small"
                    :disabled="disabled"
                    @input="change"
                  />~
                  <el-input
                    v-model="item.maxMileage"
                    :style="{width:'60px'}"
                    size="small"
                    :disabled="disabled"
                    @input="change"
                  />km
                </div>
                <div class="warminput">
                  <el-input
                    v-model="item.minTemperature"
                    :style="{width:'60px'}"
                    size="small"
                    :disabled="disabled"
                    @input="change"
                  />~
                  <el-input
                    v-model="item.maxTemperature"
                    :style="{width:'60px'}"
                    size="small"
                    :disabled="disabled"
                    @input="change"
                  />℃
                </div>
                <i
                  v-if="localValue.length > 1 && !disabled"
                  class="el-icon-remove-outline"
                  @click="remove(index)"
                />
                <i
                  v-if="localValue.length - 1 === index && localValue.length < 3 && !disabled"
                  class="el-icon-circle-plus-outline"
                  @click="add"
                />
              </div>
            </template>
          </div>
        </div>
      </el-radio-group>
    </el-card>
  </el-form-item>
</template>

<script>
const warmType = {
  freezing: {
    label: '冷冻',
    range: '-18℃以下',
  },
  coldStorage: {
    label: '冷藏',
    range: '0~10℃',
  },
};

const numberRegExp = /(^$)|(^\d+$)/;
const numberRegExp2 = /^-?\d{1,2}$/;
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'coldStorage',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localValue: {},
      rules: [
        {
          validator: (rule, value, callback) => {
            // 校验是否未选单选
            if (!value || !value.length) {
              callback(new Error('请选择标准'));
              return;
            }
            // 校验是否为标准温区
            if (value[0].type === 'DEFAULT') {
              callback();
              return;
            }
            const legal = this.computLegal(value);
            // 校验未填里程是否超过一行
            if (!legal.noMileage) {
              callback(new Error('请输入温度区间'));
              return;
            }
            if (legal.noDistance > 1) {
              callback(new Error('仅允许一行不填写里程数作为其他里程'));
              return;
            }
            // 校验一行内是否只填了一个里程
            if (!legal.hasStr) {
              callback(new Error('请输入成对里程数和温度区间'));
              return;
            }
            // 校验里程和温区数字合法性
            if (!legal.number) {
              callback(new Error('里程数仅允许填写区间[0,∞)的整数，温度区间允许填写区间[-99,99]的整数'));
              return;
            }
            // 校验里程和温区是否最大值大于最小值
            if (!legal.compare) {
              callback(new Error('每一行中，里程数最大值≥最小值，温区最大值≥最小值'));
              return;
            }
            const cross = this.computeCross(value);
            // 校验里程是否交叉
            if (cross) {
              callback(new Error('冷藏/冷冻的里程数配置不允许交叉，请仔细检查'));
              return;
            }
            // 校验最大里程以下，是否全覆盖
            // const chink = this.computeChink(value);
            // if (chink > 1) {
            //   callback(new Error('冷藏/冷冻的里程数配置未覆盖全部情况，请仔细检查'));
            //   return;
            // }
            callback();
          },
        },
      ],
    };
  },
  computed: {
    standardType: {
      get() {
        return this.localValue && this.localValue.length ? this.localValue[0].type : null;
      },
      set(val) {
        const defaultData = {
          type: val,
          minMileage: '',
          maxMileage: '',
        };
        // eslint-disable-next-line no-nested-ternary
        defaultData.minTemperature = val === 'DEFAULT' ? (this.type === 'freezing' ? '-99' : '0') : '';
        // eslint-disable-next-line no-nested-ternary
        defaultData.maxTemperature = val === 'DEFAULT' ? (this.type === 'freezing' ? '-18' : '10') : '';
        this.localValue = [
          defaultData,
        ];
        this.change();
      },
    },
    title() {
      return warmType[this.type].label;
    },
    standard() {
      return warmType[this.type].range;
    },
  },
  watch: {
    value: {
      handler(val) {
        this.localValue = val;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    change() {
      this.$emit('change', this.localValue);
    },
    add() {
      this.localValue.push({
        type: 'CUSTOM',
        minMileage: '',
        maxMileage: '',
        minTemperature: '',
        maxTemperature: '',
        // minMileage: '',
        // maxMileage: '',
        // minTemperature: '',
        // maxTemperature: '',
      });
    },
    remove(index) {
      this.localValue.splice(index, 1);
    },
    computLegal(value) {
      return value.reduce((result, item) => {
        const r = result;
        r.noMileage = r.noMileage && item.minTemperature.length && item.maxTemperature.length;
        r.noDistance = !item.minMileage && !item.maxMileage ? r.noDistance + 1 : r.noDistance;
        r.hasStr = r.hasStr && ((item.minMileage.length && item.maxMileage.length) || (!item.minMileage.length && !item.maxMileage.length));
        r.number = r.number && numberRegExp.test(item.minMileage) && numberRegExp.test(item.maxMileage)
               && numberRegExp2.test(item.minTemperature) && numberRegExp2.test(item.maxTemperature);
        r.compare = r.compare && Number(item.minMileage) <= Number(item.maxMileage) && Number(item.minTemperature) <= Number(item.maxTemperature);
        return r;
      }, {
        noDistance: 0,
        hasStr: true,
        number: true,
        compare: true,
        noMileage: true,
      });
    },
    computeCross(value) {
      const customize = value.filter((item) => item.maxMileage.length && item.minMileage.length);
      const cross = customize.reduce((result, item) => result || customize.filter((i) => i !== item).some((i) => (Number(item.minMileage) < Number(i.maxMileage)) && (Number(item.maxMileage) > Number(i.minMileage))), false);
      return cross;
    },
    computeChink(value) {
      const customize = value.filter((item) => item.maxMileage.length && item.minMileage.length)
        .map((item) => [Number(item.minMileage), Number(item.maxMileage)]);
      return customize.reduce((result, item) => {
        if (!customize.filter((i) => i !== item).some((i) => i[0] === item[1])) {
          return result + 1;
        }
        return result;
      }, Math.min(...customize.flat()) !== 0 ? 1 : 0);
      // 低效方案
      // const numbers = customize.flat();
      // let distance = new Array(Math.max(...numbers)).fill(true);
      // customize.forEach((item) => {
      //   const length = item[1] - item[0];
      //   distance.splice(item[0], length, ...(new Array(length).fill(false)));
      // });
      // distance = distance.filter((i) => i);
      // return !!distance.length;
    },
  },
};
</script>
<style lang="scss" scoped>
.warm{
  + .warm{
    margin-left: 24px;
  }
  .warm-container{
    width: 580px;
  }

  .radio-input{
    flex:1;
  }
  ::v-deep .el-card__body{
    padding:12px;
  }
  .warm-title{
    font-size: 14px;
    margin-bottom: 18px;
  }
  .radio-item{
    + .radio-item{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      font-size: 14px;
      margin-top:12px;
      .el-radio{
        height: 32px;
        line-height: 32px;
      }
    }
    .customize-item{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      + .customize-item{
        margin-top: 8px;
      }
      > div{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 10px;
      }
      .warminput{
        margin-right: 15px;
      }
      .el-icon-remove-outline{
        font-size: 18px;
        margin-right: 5px;
        cursor: pointer;
        color:red;
      }
      .el-icon-circle-plus-outline{
        font-size: 18px;
        cursor: pointer;
        color:#059E84
      }
      .el-input{
        margin:0 3px;
      }
    }
  }
}
</style>
